import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/voucher-pool?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/voucher/voucher-pool/${id}`, { params });
}

export async function create(body) {
  return request(`/voucher/voucher-pool`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/voucher/voucher-pool/${id}`, {
    method: 'POST',
    body,
  });
}

export async function approve(id, body) {
  return request(`/voucher/voucher-pool/commit/${id}`, {
    method: 'POST',
    body,
  });
}